// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersUnitMobile_filters-unit-mobile__X458F {
  display: flex;
  gap: 8px;
  align-items: center;
}
.FiltersUnitMobile_filters-unit-mobile__X458F .FiltersUnitMobile_filter-trigger__Zz3vK svg {
  border: 1px solid var(--secondary-color);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 5px;
}
.FiltersUnitMobile_filters-unit-mobile__X458F .FiltersUnitMobile_filter-trigger__Zz3vK svg path {
  stroke: var(--secondary-color);
  stroke-width: 1px;
}

.ant-drawer-footer .FiltersUnitMobile_filters-footer__\\+TRjH {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.ant-drawer-footer .FiltersUnitMobile_filters-footer__\\+TRjH .FiltersUnitMobile_apply-button__a3\\+e4 {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: black;
  color: white;
  cursor: pointer;
}
.ant-drawer-footer .FiltersUnitMobile_filters-footer__\\+TRjH .FiltersUnitMobile_clear-button__zI071 {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  margin-right: 10px;
}

.ant-drawer-body .FiltersUnitMobile_title-filter__bAgci {
  color: var(--public-profile-color);
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersUnitMobile_title-sub-filter__NNw6o {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersUnitMobile_title-sub-filter-affiliation__nUqZG {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersUnitMobile_search-sub-filter__HNL1r {
  margin-top: 5px;
}
.ant-drawer-body .FiltersUnitMobile_position__ZPf7k {
  margin-bottom: 15px;
}
.ant-drawer-body .FiltersUnitMobile_seniority__qNzWP {
  margin-bottom: 15px;
}
.ant-drawer-body .FiltersUnitMobile_sub-filter__pTplU {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitList/Components/FiltersUnitMobile/FiltersUnitMobile.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;AACI;EACE,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACN;AAAM;EACE,8BAAA;EACA,iBAAA;AAER;;AAKE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAFJ;AAGI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AADN;AAGI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AADN;;AAME;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ","sourcesContent":[".filters-unit-mobile {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  .filter-trigger {\n    svg {\n      border: 1px solid var(--secondary-color);\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      padding: 5px;\n      path {\n        stroke: var(--secondary-color);\n        stroke-width: 1px;\n      }\n    }\n  }\n}\n\n:global(.ant-drawer-footer) {\n  .filters-footer {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    .apply-button {\n      width: 100px;\n      height: 40px;\n      border-radius: 10px;\n      border: none;\n      background: black;\n      color: white;\n      cursor: pointer;\n    }\n    .clear-button {\n      width: 100px;\n      height: 40px;\n      border-radius: 10px;\n      border: none;\n      cursor: pointer;\n      margin-right: 10px;\n    }\n  }\n}\n:global(.ant-drawer-body) {\n  .title-filter {\n    color: var(--public-profile-color);\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .title-sub-filter {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .title-sub-filter-affiliation {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .search-sub-filter {\n    margin-top: 5px;\n  }\n  .position {\n    margin-bottom: 15px;\n  }\n  .seniority {\n    margin-bottom: 15px;\n  }\n  .sub-filter {\n    margin-bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-unit-mobile": `FiltersUnitMobile_filters-unit-mobile__X458F`,
	"filter-trigger": `FiltersUnitMobile_filter-trigger__Zz3vK`,
	"filters-footer": `FiltersUnitMobile_filters-footer__+TRjH`,
	"apply-button": `FiltersUnitMobile_apply-button__a3+e4`,
	"clear-button": `FiltersUnitMobile_clear-button__zI071`,
	"title-filter": `FiltersUnitMobile_title-filter__bAgci`,
	"title-sub-filter": `FiltersUnitMobile_title-sub-filter__NNw6o`,
	"title-sub-filter-affiliation": `FiltersUnitMobile_title-sub-filter-affiliation__nUqZG`,
	"search-sub-filter": `FiltersUnitMobile_search-sub-filter__HNL1r`,
	"position": `FiltersUnitMobile_position__ZPf7k`,
	"seniority": `FiltersUnitMobile_seniority__qNzWP`,
	"sub-filter": `FiltersUnitMobile_sub-filter__pTplU`
};
export default ___CSS_LOADER_EXPORT___;
